export default __webpack_public_path__ + "static/media/IMG_5086_min.cb12dc6c.png";